export default {
  methods: {
    sortTaxons(taxons) {
      return [...taxons].sort(
        (a, b) => a.name.localeCompare(
          b.name, this['search/locale'], { ignorePunctuation: true },
        ),
      );
    },
  },
};
